import { Currency, Locale } from '@bemlo/enums'

export type FormatSekRangeOptions = {
  roundToNearest?: number
  spaced?: boolean
}

export const formatCurrency =
  (locale: Locale) =>
  (currency: Currency, value: number, roundToNearest = 1) => {
    if (value == null) {
      return '-'
    }

    // Double-rounding just to be sure we avoid IEEE 754 rounding errors:
    const roundedValue = Math.round(
      Math.round(value / roundToNearest) * roundToNearest,
    )

    return roundedValue.toLocaleString(locale, {
      currency,
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
      style: 'currency',
    })
  }

export const formatCurrencyRange =
  (locale: Locale) =>
  (
    currency: Currency,
    min: number | null | undefined,
    max: number | null | undefined,
    options: FormatSekRangeOptions = {},
  ) => {
    if (min == null || max == null) {
      return '-'
    }

    if (min != null && max != null && min > max) {
      ;[min, max] = [max, min]
    }

    const formattedMax = formatCurrency(locale)(
      currency,
      max,
      options.roundToNearest,
    )
    if (min === max) {
      return formattedMax
    }

    const delimiter = options.spaced ? ' – ' : '–'
    const formattedMin = formatCurrency(locale)(
      currency,
      min,
      options.roundToNearest,
    )
    return `${formattedMin}${delimiter}${formattedMax}`
  }
